import gql from "graphql-tag";

export const AlertFragment = gql`
  fragment AlertFragment on Alert{
    id,
    name,
    alert_template_id,
    start_date,
    end_date,
    first_alert_time,
    second_alert_time,
    memo_id,
    disabled,
    phones,
    emails
  }
`;

export const EmailFragment = gql`
fragment EmailFragment on Email{
  id,
  email,
  active
}
`;

export const MemoFragment = gql`
fragment MemoFragment on Memo{
  id,
  category_id,
  name,
  disabled,
}
`;

export const MemoPhotoFragment = gql`
fragment MemoPhotoFragment on MemoPhoto{
  id,
  uri,
  memo_id,
  localUri
}
`;

export const PhoneFragment = gql`
fragment PhoneFragment on Phone{
  id,
  phone_number,
  active
}
`;

export const SubscriptionFragment = gql`
fragment SubscriptionFragment on Subscription{
  name,
  braintreePlan,
  endsAt,
  createdAt,
  isActive
}
`;

export const UserFragment = gql`
fragment UserFragment on User{
  id,
  primary_phone_id,
  primary_email_id,
  subscribed,
  name,
  type,
  address,
  unique_identifier,
  subscription{
    ...SubscriptionFragment
  }
}
${SubscriptionFragment}
`;


// WEBPACK FOOTER //
// ./src/api/fragments.ts